"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTradeOrderStatus = exports.TokenTradeOrderType = exports.TokenPurchaseAge = exports.TokenDropStatus = exports.TokenDistributionType = exports.TokenStatus = void 0;
/**
 * Token Status.
 */
var TokenStatus;
(function (TokenStatus) {
    TokenStatus["AVAILABLE"] = "available";
    TokenStatus["CANCEL_SALE"] = "cancel_sale";
    TokenStatus["PROCESSING"] = "processing";
    TokenStatus["PRE_MINTED"] = "pre_minted";
    TokenStatus["ERROR"] = "error";
    TokenStatus["MINTING"] = "minting";
    TokenStatus["MINTED"] = "minted";
    TokenStatus["MINTING_ERROR"] = "minting_error";
    TokenStatus["BASE"] = "base";
})(TokenStatus || (exports.TokenStatus = TokenStatus = {}));
/**
 * Token distributuion Type.
 */
var TokenDistributionType;
(function (TokenDistributionType) {
    TokenDistributionType["FIXED"] = "fixed";
})(TokenDistributionType || (exports.TokenDistributionType = TokenDistributionType = {}));
/**
 * Token Drop status.
 */
var TokenDropStatus;
(function (TokenDropStatus) {
    TokenDropStatus["DEPOSIT_NEEDED"] = "deposit_needed";
    TokenDropStatus["UNCLAIMED"] = "unclaimed";
    TokenDropStatus["CLAIMED"] = "claimed";
})(TokenDropStatus || (exports.TokenDropStatus = TokenDropStatus = {}));
/**
 * Token purchase age.
 */
var TokenPurchaseAge;
(function (TokenPurchaseAge) {
    TokenPurchaseAge["IN_24_H"] = "in24h";
    TokenPurchaseAge["IN_48_H"] = "in48h";
    TokenPurchaseAge["IN_7_D"] = "in7d";
})(TokenPurchaseAge || (exports.TokenPurchaseAge = TokenPurchaseAge = {}));
/**
 * Token order type.
 */
var TokenTradeOrderType;
(function (TokenTradeOrderType) {
    TokenTradeOrderType["BUY"] = "buy";
    TokenTradeOrderType["SELL"] = "sell";
})(TokenTradeOrderType || (exports.TokenTradeOrderType = TokenTradeOrderType = {}));
/**
 * Token Order status
 */
var TokenTradeOrderStatus;
(function (TokenTradeOrderStatus) {
    TokenTradeOrderStatus["ACTIVE"] = "active";
    TokenTradeOrderStatus["SETTLED"] = "settled";
    TokenTradeOrderStatus["CANCELLED"] = "cancelled";
    TokenTradeOrderStatus["PARTIALLY_SETTLED_AND_CANCELLED"] = "partially_settled_and_cancelled";
    TokenTradeOrderStatus["EXPIRED"] = "expired";
    TokenTradeOrderStatus["CANCELLED_UNFULFILLABLE"] = "cancelled_unfulfillable";
    TokenTradeOrderStatus["CANCELLED_MINTING_TOKEN"] = "cancelled_minting_token";
})(TokenTradeOrderStatus || (exports.TokenTradeOrderStatus = TokenTradeOrderStatus = {}));
